import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Clock } from "lucide-react";
import { Switch } from "@/components/ui/switch";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DAYS = [["mon", "Lundi"], ["tue", "Mardi"], ["wed", "Mercredi"], ["thu", "Jeudi"], ["fri", "Vendredi"], ["sat", "Samedi"], ["sun", "Dimanche"]];
const DEFAULT = { closed: false, open: "11:00", close: "23:00" };

const DayRow = ({ id, label, v, onChange }) => (
  <div className="flex items-center gap-2 text-xs" data-testid={`hours-row-${id}`}>
    <span className="w-20 font-bold">{label}</span>
    <Switch className="shrink-0" checked={!v.closed} onCheckedChange={(o) => onChange({ ...v, closed: !o })} data-testid={`hours-open-${id}`} />
    {v.closed ? <span className="text-rose-300 font-bold">Fermé</span> : (
      <>
        <input type="time" value={v.open} onChange={(e) => onChange({ ...v, open: e.target.value })} className="bg-[#0F172A] border border-white/10 rounded-lg px-2 py-1" data-testid={`hours-from-${id}`} />
        <span>→</span>
        <input type="time" value={v.close} onChange={(e) => onChange({ ...v, close: e.target.value })} className="bg-[#0F172A] border border-white/10 rounded-lg px-2 py-1" data-testid={`hours-to-${id}`} />
      </>
    )}
  </div>
);

// Horaires d'ouverture jour par jour (en dehors : menu « Fermé », commandes bloquées)
export const RestaurantHoursEditor = () => {
  const [hours, setHours] = useState(null);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    axios.get(`${API}/restaurant/settings`).then(({ data }) => {
      setHours(Object.fromEntries(DAYS.map(([d]) => [d, data.hours?.[d] || DEFAULT])));
      setIsOpen(data.is_open);
    }).catch(() => setHours(Object.fromEntries(DAYS.map(([d]) => [d, DEFAULT]))));
  }, []);

  const save = async () => {
    try {
      const { data } = await axios.put(`${API}/restaurant/settings/hours`, { hours });
      setIsOpen(data.is_open);
      toast.success("Horaires enregistrés");
    } catch (e) {
      toast.error("Horaires invalides");
    }
  };

  if (!hours) return null;
  return (
    <section className="bg-[#1E293B] border border-white/5 rounded-2xl p-4 space-y-3" data-testid="restaurant-hours-editor">
      <div className="flex items-center justify-between">
        <h3 className="text-xs font-black uppercase tracking-widest flex items-center gap-2"><Clock size={14} className="text-[#D4AF37]" /> Horaires d'ouverture</h3>
        <span className={`text-[10px] font-black uppercase ${isOpen ? "text-emerald-400" : "text-rose-300"}`} data-testid="restaurant-open-status">{isOpen ? "Ouvert maintenant" : "Fermé maintenant"}</span>
      </div>
      {DAYS.map(([d, label]) => <DayRow key={d} id={d} label={label} v={hours[d]} onChange={(v) => setHours((h) => ({ ...h, [d]: v }))} />)}
      <button type="button" onClick={save} className="w-full rounded-full bg-[#D4AF37] text-[#0F172A] py-2.5 text-[11px] font-black uppercase tracking-widest" data-testid="hours-save-btn">Enregistrer les horaires</button>
    </section>
  );
};
